var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File_folder",
    "data-name": "File folder"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.522,57.445l4.806-26.033A3,3,0,0,0,56.355,28H12.445a3.019,3.019,0,0,0-2.967,2.555L4.2,60h47.36A3.019,3.019,0,0,0,54.522,57.445Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,26h2V7a1,1,0,0,1,1-1H46V4H14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,49.763,7.5,30.23A4.943,4.943,0,0,1,12,26.04V12.184A3,3,0,0,0,10,15v2a1,1,0,0,1-1,1H7a3,3,0,0,0-3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,18.184V26h2V21A3,3,0,0,0,52,18.184Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,26H50V8H18Zm3-16H47a1,1,0,0,1,0,2H21a1,1,0,0,1,0-2Zm0,4H47a1,1,0,0,1,0,2H21a1,1,0,0,1,0-2Zm0,4H47a1,1,0,0,1,0,2H21a1,1,0,0,1,0-2Zm0,4H47a1,1,0,0,1,0,2H21a1,1,0,0,1,0-2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageData);
export default __webpack_public_path__ + "static/media/manageData.d1e38b88c9ce73db2390d279391053ee.svg";
export { ForwardRef as ReactComponent };